import { Component,ViewChild, ChangeDetectorRef } from '@angular/core';
import {NavController, ModalController, LoadingController} from 'ionic-angular';
import { Params } from '../params';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import {MenuDiarioPage} from "../menus/menus";
import { Chart } from 'chart.js';
import { Http } from '@angular/http';
import {CustomerHistoryPage} from "./customer-history/customer-history";
import { GlobalProvider } from "../../providers/global/global";


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  @ViewChild('lineCanvas') lineCanvas;
  @ViewChild('yearlyChart') yearlyChart;
  customers = null;
  nombre:string;
  email:string;
  msg: string;
  printed : boolean = false;
  showprinted : boolean = false;
  lineChart: any;
  chartOk : boolean = false;
  yearlyChartOk : boolean = false;
  month;
  years = [];
  year;
  rows = [];
  actualData = {};
  labels = [];
  data  = [];
  show : boolean = false;
  loading : boolean = false;
  loadingG : boolean = false;
  counters = {};
  totals = {
    customers: 0,
    comeback: 0,
    outcome: 0,
    income: 0,
    foods: 0
  }
  modules = {
    "invoice" : "#ccc",
    "print" : "#ccc",
    "order" : "#ccc",
    "ration" : "#ccc",
    "incident" : "#ccc"
  }
  constructor(
    public navCtrl: NavController,
    private modalCtrl : ModalController,
    public http: Http,
    public global: GlobalProvider,
    public cdr: ChangeDetectorRef) {
    this.nombre = Params.USER_DATA.name;
    this.email = Params.USER_DATA.email;


    if(Params.USER_DATA.roles.indexOf("PLA")!=-1) {
      this.modules.print = "black"
      this.showprinted = true;
    }

    let today = moment().format("YYYYMMDD");

    let actual_year = Number(moment().format("YYYY"));
    let first_year = 2017;
    let end = (actual_year-first_year)+2;
    for(let y=0;y<end;y++){
      this.years.push(first_year+y);
    }

    this.month = moment().format("MM");
    this.year = actual_year;

    this.customers = this.global.customers;

  }

  generate(){
    this.cdr.detectChanges();
    this.loadingG = true;
    this.http.post('https://admin.fitfood.cl/generateConsolidated',{ month : this.month, year: this.year})
    // this.http.post('http://localhost:5000/fitfood-22c23/us-central1/generateConsolidated',{ month : this.month, year: this.year})
      .subscribe((resp)=>{
        console.log("!!!!",resp);
        this.loadingG = false;
      })
  }


  loadYearly(type){
    firebase.firestore().collection('resume').get()
      .then((snap) => {
        this.labels = [];
        this.data = [];

        snap.forEach((x) => {
          this.labels.push(x.id);
          this.data.push(x.data()[type])

        })

        console.log(this.labels, this.data);

        this.yearlyChart.data.labels = this.labels;
        this.yearlyChart.data.datasets[0].data = this.data;
        this.yearlyChart.update();
      })
  }

  filter(){
    this.totals = {
      customers: 0,
      comeback: 0,
      outcome: 0,
      income: 0,
      foods: 0
    }
    console.log("filter")
    this.show = false;
    this.loading = true;
    const firstDay = moment(this.year+"/"+this.month+"/01")
    const lastDay = firstDay.clone().endOf("month");
    const diff = lastDay.diff(firstDay, 'days')+1;
    let labels = [];
    let data = [];
    let ok = 0;
    this.rows = [];

    setTimeout(()=> {
      this.yearlyChart = new Chart(this.yearlyChart.nativeElement, {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: [
            {
              label: "Datos",
              fill: false,
              lineTension: 0.1,
              backgroundColor: "orange",
              borderColor: "orange",
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointBorderColor: "rgba(75,192,192,1)",
              pointBackgroundColor: "#fff",
              pointBorderWidth: 1,
              pointHoverRadius: 5,
              pointHoverBackgroundColor: "rgba(75,192,192,1)",
              pointHoverBorderColor: "rgba(220,220,220,1)",
              pointHoverBorderWidth: 2,
              pointRadius: 1,
              pointHitRadius: 10,
              data: this.data,
              spanGaps: false,
            }
          ]
        }

      });
    },5000);

    firebase.firestore().collection('resume').doc(this.year+this.month)
      .get().then((snap)=>{
        if(snap.exists){
          const data = snap.data();
          this.actualData = data;
          let labels = [];
          let clientes = [];
          let reingresos = [];
          let nuevos = [];
          let salidas = [];
          let comidas = [];

          if(data.days){
            data.detail = Object.keys(data.days).map((x)=>{
              this.totals.customers = this.totals.customers + data.days[x].total_shipping;
              this.totals.comeback = this.totals.comeback + data.days[x].total_comeback;
              this.totals.outcome = this.totals.outcome + data.days[x].total_outcome;
              this.totals.income = this.totals.income + data.days[x].total_income;
              this.totals.foods = this.totals.foods + data.days[x].total_foods;
              labels.push(data.days[x].day_short);
              clientes.push(data.days[x].total_shipping);
              reingresos.push(data.days[x].total_comeback);
              nuevos.push(data.days[x].total_income);
              salidas.push(data.days[x].total_outcome);
              comidas.push(data.days[x].total_foods);
              return data.days[x];
            }).sort((a, b) => {
              if (a.day_normal > b.day_normal) return 1;
              if (b.day_normal > a.day_normal) return -1;
              return 0;
            })
          } else {
            data.detail.map((x)=>{
              this.totals.customers = this.totals.customers + x.total_shipping;
              this.totals.comeback = this.totals.comeback + x.total_comeback;
              this.totals.outcome = this.totals.outcome + x.total_outcome;
              this.totals.income = this.totals.income + x.total_income;
              this.totals.foods = this.totals.foods + x.total_foods;
              labels.push(x.day_short);
              clientes.push(x.total_shipping);
              reingresos.push(x.total_comeback);
              nuevos.push(x.total_income);
              salidas.push(x.total_outcome);
              comidas.push(x.total_foods);
            });
          }
          this.counters = data;
          console.log(this.counters);
          this.show = true;
          this.loading = false;
          this.chartOk = true;
          setTimeout(()=> {
            if(this.lineCanvas){
              this.lineChart = new Chart(this.lineCanvas.nativeElement, {
                type: 'line',
                data: {
                  labels: labels,
                  datasets: [
                    {
                      label: "Clientes",
                      fill: false,
                      lineTension: 0.1,
                      backgroundColor: "purple",
                      borderColor: "red",
                      borderCapStyle: 'butt',
                      borderDash: [],
                      borderDashOffset: 0.0,
                      borderJoinStyle: 'miter',
                      pointBorderColor: "rgba(75,192,192,1)",
                      pointBackgroundColor: "#fff",
                      pointBorderWidth: 1,
                      pointHoverRadius: 5,
                      pointHoverBackgroundColor: "rgba(75,192,192,1)",
                      pointHoverBorderColor: "rgba(220,220,220,1)",
                      pointHoverBorderWidth: 2,
                      pointRadius: 1,
                      pointHitRadius: 10,
                      data: clientes,
                      spanGaps: false,
                    },{
                      label: "Reingresos",
                      fill: false,
                      lineTension: 0.1,
                      backgroundColor: "yellow",
                      borderColor: "orange",
                      borderCapStyle: 'butt',
                      borderDash: [],
                      borderDashOffset: 0.0,
                      borderJoinStyle: 'miter',
                      pointBorderColor: "rgba(75,192,192,1)",
                      pointBackgroundColor: "#fff",
                      pointBorderWidth: 1,
                      pointHoverRadius: 5,
                      pointHoverBackgroundColor: "rgba(75,192,192,1)",
                      pointHoverBorderColor: "rgba(220,220,220,1)",
                      pointHoverBorderWidth: 2,
                      pointRadius: 1,
                      pointHitRadius: 10,
                      data: reingresos,
                      spanGaps: false,
                    },{
                      label: "Nuevos",
                      fill: false,
                      lineTension: 0.1,
                      backgroundColor: "rgba(75,192,192,0.4)",
                      borderColor: "green",
                      borderCapStyle: 'butt',
                      borderDash: [],
                      borderDashOffset: 0.0,
                      borderJoinStyle: 'miter',
                      pointBorderColor: "rgba(75,192,192,1)",
                      pointBackgroundColor: "#fff",
                      pointBorderWidth: 1,
                      pointHoverRadius: 5,
                      pointHoverBackgroundColor: "rgba(75,192,192,1)",
                      pointHoverBorderColor: "rgba(220,220,220,1)",
                      pointHoverBorderWidth: 2,
                      pointRadius: 1,
                      pointHitRadius: 10,
                      data: nuevos,
                      spanGaps: false,
                    },{
                      label: "Salidas",
                      fill: false,
                      lineTension: 0.1,
                      backgroundColor: "lightblue",
                      borderColor: "blue",
                      borderCapStyle: 'butt',
                      borderDash: [],
                      borderDashOffset: 0.0,
                      borderJoinStyle: 'miter',
                      pointBorderColor: "rgba(75,192,192,1)",
                      pointBackgroundColor: "#fff",
                      pointBorderWidth: 1,
                      pointHoverRadius: 5,
                      pointHoverBackgroundColor: "rgba(75,192,192,1)",
                      pointHoverBorderColor: "rgba(220,220,220,1)",
                      pointHoverBorderWidth: 2,
                      pointRadius: 1,
                      pointHitRadius: 10,
                      data: salidas,
                      spanGaps: false,
                    },{
                      label: "Comidas",
                      fill: false,
                      lineTension: 0.1,
                      backgroundColor: "orange",
                      borderColor: "orange",
                      borderCapStyle: 'butt',
                      borderDash: [],
                      borderDashOffset: 0.0,
                      borderJoinStyle: 'miter',
                      pointBorderColor: "rgba(75,192,192,1)",
                      pointBackgroundColor: "#fff",
                      pointBorderWidth: 1,
                      pointHoverRadius: 5,
                      pointHoverBackgroundColor: "rgba(75,192,192,1)",
                      pointHoverBorderColor: "rgba(220,220,220,1)",
                      pointHoverBorderWidth: 2,
                      pointRadius: 1,
                      pointHitRadius: 10,
                      data: comidas,
                      spanGaps: false,
                    }
                  ]
                }

              });
            }
          },1500)
        }
    })
  }

  fromNow(date){
    return moment(date).fromNow();
  }

  fromDate(from,to){
    try{
      let fr = this.customers[from].datestart;
      return moment(to).from(fr,true);
    }catch(e){
      return "";
    }

  }

  history(i){
    let modal = this.modalCtrl.create(CustomerHistoryPage, {
      data : {
        customerId : i,
        customer : this.customers[i],
      }
    });
    modal.present();
  }

  customerName(i){
    let name = "";
    try{
      name = this.customers[i].name + " " + this.customers[i].lastname
    }catch(e){

    }
    return name;
  }

  diff(){
    let total = "0";
    if(Object.keys(this.counters).length){
      const temp = (this.counters["total_income"]+this.counters["total_comeback"])-this.counters["total_outcome"];
      total = temp.toString();
      if(temp>0) total = "+"+temp;
    }
    return total;
  }

  format(num){
    if(isNaN(num)){
      return 0;
    } else{
      return num.toFixed(2)
    }

  }

  print(){
    if(this.showprinted){
      this.navCtrl.setRoot(MenuDiarioPage);
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts